import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ExportSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/lead-generator');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      <div className="bg-white shadow-lg rounded-lg p-8 w-full max-w-md text-center">
        <div className="mb-6">
          <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
            <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-green-600 mb-2">Payment Successful!</h1>
          <p className="text-gray-600 mb-4">
            Your lead export credits have been added to your account. You can now return to the Lead Generator to export your leads.
          </p>
        </div>
        
        <div className="mb-6">
          <p className="text-sm text-gray-500">
            Redirecting to Lead Generator in {countdown} seconds...
          </p>
        </div>
        
        <div className="space-y-2">
          <button
            onClick={() => navigate('/lead-generator')}
            className="w-full px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
          >
            Return to Lead Generator
          </button>
          <button
            onClick={() => navigate('/')}
            className="w-full px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExportSuccess;